module.exports = __webpack_public_path__ + "img/qhl.ce68b171.png";